import { displayDate } from "src/utils/dateHandler.util";
import { SessionWithUsers } from "../../../types";

import { FiUser as User, FiInfo as Info } from "react-icons/fi";

export const ParticipantsActionSection: React.FC<SessionWithUsers> = ({ session, users }) => (
  <div className="space-y-3">
    {session.participantActions && Object.keys(session.participantActions).length > 0 ? (
      Object.entries(session.participantActions).map(([userId, actions]) =>
        actions.map((action, index) => (
          <div
            key={`${userId}-${index}`}
            className="flex items-center space-x-4 p-4 bg-gradient-to-r from-gray-50 to-slate-50 rounded-xl border border-gray-200 hover:border-gray-300 transition-all"
          >
            <div className="flex-shrink-0 p-3 bg-white rounded-lg shadow-sm">
              <User className="w-5 h-5 text-gray-600" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-gray-900">
                {users[userId]?.name || userId}
                <span className="ml-2 text-gray-600 font-normal">{action.action.toLowerCase()}</span>
              </p>
              <p className="text-xs text-gray-500 mt-1">{displayDate(action.timestamp)}</p>
            </div>
          </div>
        ))
      )
    ) : (
      <div className="flex flex-col items-center justify-center py-8 text-gray-500">
        <Info className="w-8 h-8 mb-2 opacity-50" />
        <span>No participants recorded</span>
      </div>
    )}
  </div>
);
